export const topicsData = [
  {
    id: 'math-basics',
    name: 'Math Basics',
    description: 'Test your knowledge of fundamental mathematical concepts including arithmetic, algebra, and geometry.',
    imageUrl: 'https://images.unsplash.com/photo-1635070041078-e363dbe005cb?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80',
    category: 'mathematics',
    difficulty: 'medium',
    questionCount: 50
  },
  {
    id: 'world-history',
    name: 'World History',
    description: 'Explore major historical events, civilizations, and figures that shaped our world.',
    imageUrl: 'https://images.unsplash.com/photo-1461360228754-6e81c478b882?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80',
    category: 'history',
    difficulty: 'hard',
    questionCount: 45
  },
  {
    id: 'general-science',
    name: 'General Science',
    description: 'Test your knowledge of basic scientific principles across physics, chemistry, and biology.',
    imageUrl: 'https://images.unsplash.com/photo-1532094349884-543bc11b234d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80',
    category: 'science',
    difficulty: 'medium',
    questionCount: 60
  },
  {
    id: 'computer-science',
    name: 'Computer Science',
    description: 'Challenge yourself with questions about programming, algorithms, and computer systems.',
    imageUrl: 'https://images.unsplash.com/photo-1550439062-609e1531270e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80',
    category: 'technology',
    difficulty: 'hard',
    questionCount: 40
  },
  {
    id: 'english-grammar',
    name: 'English Grammar',
    description: 'Improve your understanding of English grammar rules, vocabulary, and language usage.',
    imageUrl: 'https://images.unsplash.com/photo-1456513080510-7bf3a84b82f8?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80',
    category: 'language',
    difficulty: 'easy',
    questionCount: 55
  },
  {
    id: 'geography',
    name: 'Geography',
    description: 'Test your knowledge of countries, capitals, landforms, and global geography.',
    imageUrl: 'https://images.unsplash.com/photo-1526778548025-fa2f459cd5ce?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80',
    category: 'geography',
    difficulty: 'medium',
    questionCount: 50
  },
  {
    id: 'biology',
    name: 'Biology',
    description: 'Explore the fascinating world of living organisms, ecosystems, and human anatomy.',
    imageUrl: 'https://images.unsplash.com/photo-1530210124550-912dc1381cb8?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80',
    category: 'science',
    difficulty: 'medium',
    questionCount: 45
  },
  {
    id: 'physics',
    name: 'Physics',
    description: 'Challenge yourself with questions about the fundamental laws that govern our universe.',
    imageUrl: 'https://images.unsplash.com/photo-1636466497217-26a42372b5e9?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80',
    category: 'science',
    difficulty: 'hard',
    questionCount: 40
  },
  {
    id: 'literature',
    name: 'Literature',
    description: 'Test your knowledge of classic and contemporary literature, authors, and literary devices.',
    imageUrl: 'https://images.unsplash.com/photo-1544716278-ca5e3f4abd8c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80',
    category: 'arts',
    difficulty: 'medium',
    questionCount: 35
  },
  {
    id: 'basic-coding',
    name: 'Basic Coding',
    description: 'Learn the fundamentals of programming with questions on basic coding concepts.',
    imageUrl: 'https://images.unsplash.com/photo-1555066931-4365d14bab8c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80',
    category: 'technology',
    difficulty: 'easy',
    questionCount: 30
  },
  {
    id: 'chemistry',
    name: 'Chemistry',
    description: 'Explore the world of elements, compounds, and chemical reactions.',
    imageUrl: 'https://images.unsplash.com/photo-1603126857599-f6e157fa2fe6?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80',
    category: 'science',
    difficulty: 'hard',
    questionCount: 40
  },
  {
    id: 'ancient-civilizations',
    name: 'Ancient Civilizations',
    description: 'Journey through the fascinating history of ancient Egypt, Greece, Rome, and more.',
    imageUrl: 'https://images.unsplash.com/photo-1608329597181-a7b280942b92?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80',
    category: 'history',
    difficulty: 'medium',
    questionCount: 35
  }
];
